import { render, staticRenderFns } from "./DistributionChannel.vue?vue&type=template&id=7f60accd&scoped=true&lang=html"
import script from "./DistributionChannel.vue?vue&type=script&lang=js"
export * from "./DistributionChannel.vue?vue&type=script&lang=js"
import style0 from "./DistributionChannel.vue?vue&type=style&index=0&id=7f60accd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f60accd",
  null
  
)

export default component.exports